'use client';

import React from 'react';

import { RightMenu } from './RightMenu';

import MoveBack from '~/assets/icons/gnb/ic_back_24x24.svg';

type Props = {
  title?: string | React.ReactNode;
  right?: React.ReactNode;
  onLeftClick?: (() => void) | null;
};

const LeftButton = ({ onLeftClick }: { onLeftClick?: () => void }) => {
  return (
    <button
      type="button"
      className="size-24 after-back-button after:content-['']"
      onClick={onLeftClick}
    >
      <MoveBack className="w-24 fill-current" />
    </button>
  );
};

export function AppBar({ title, right, onLeftClick, ...props }: Props) {
  return (
    <nav className="sticky top-0 z-20 m-auto flex h-[60px] max-w-3xl items-center justify-between bg-screen-01 px-16 text-normal">
      <div className="mr-12 flex flex-1 items-center">
        {onLeftClick && <LeftButton onLeftClick={onLeftClick} {...props} />}
      </div>
      <div className="max-w-[256px] truncate text-center typo-title100-semibold">
        {title}
      </div>
      <div className="ml-12 flex flex-1 justify-end">
        {right ?? <RightMenu />}
      </div>
    </nav>
  );
}
